<template>
	<label :for="id + value">
	  <input type="radio" 
      :id="id + value" 
      :name="name" 
      :value="value"
      v-model="internalSelected" />
		{{ label }}
	</label>
</template>

<script>
export default {
  name: "AcRadio",
  props: {
    // The name for all radio options
    name: {
      required: true,
      type: String
    },

    label: {
      required: true,
      type: String
    },

    value: {
      required: true,
      type: String
    },

    // The currently selected option
    selected: {
      required: false,
      type: String
    }
  },
  data() {
    return {
      id: this.randomString(),
      internalSelected: this.selected
    };
  },
  watchers: {
    internalSelected(val) {
      this.$emit("change", val);
    }
  },
  methods: {
    randomString() {
      // Generate a random string for unique ID's that map to each "for" attribute
      return (
        Math.random()
          .toString(36)
          .substring(2, 15) +
        Math.random()
          .toString(36)
          .substring(2, 15)
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// admin/src/js/components/AcRadio.vue